// @ts-nocheck


import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import notification from 'antd/lib/notification';
import moment from 'moment';
import _orderBy from 'lodash/orderBy';

import { vehicleApi } from '../../lib/api';
import wialonApi from '../../lib/api/wialon';
import {
  hideSidebarBurger,
  closeSidebar,
  openSidebar,
  showSidebarBurger } from
'../../ducks/sidebar';
import { Icon, Loading } from '../../components/ui';
import { VehicleInfo, VehiclesList } from './components';
import { geocode } from '../../lib/gis';




import { Wrapper, Content, MapWrapper, Sidebar, BackButton } from './styles';

import { defaultPageSize, goBack } from '../../lib/helpers';
import {
  monitoringVehicleStatesEnum,
  monitoringVehicleStatusesEnum } from
'../../lib/enum';

import MonitoringMap from '../../components/maps/monitoringMap';
import {
  bindPlaybackTicks,
  createPlaybackData,
  createTrackPlayback,
  disposeTrackPlayback } from
'./playbackAdapter';









export const basePlaybackSpeed = 8;

/**
 * Состояние вкладки история
 */



















/**
 * Главное окно мониторинга
 */
export const MonitoringScreen = ({
  showSidebarBurger,
  openSidebar,
  closeSidebar,
  hideSidebarBurger,
  location
}) => {
  const [data, setData] = useState({});
  const [activeMonitoringVehicles, setActiveMonitoringVehicles] = useState(

    new Map());
  // Список ТС
  const [vehicles, setVehicles] = useState([]);
  // Список ТС для восстановления фильтрации
  const [originalVehicles, setOriginalVehicles] = useState(
    []
  );
  // Выбранное ТС
  const [
  selectedMonitoringVehicle,
  setSelectedMonitoringVehicle] =
  useState(undefined);
  const [vehicleInfoOpen, setVehicleInfoOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPaginationObj] = useState({
    page: 1,
    pageSize: defaultPageSize,
    totalCount: 0
  });
  // Состояние истории
  const [historyState, setHistoryState] = useState({
    speed: 1,
    status: 'pause',
    startDate: moment('00:00', 'HH:mm').toDate(),
    endDate: moment('23:59', 'HH:mm').toDate(),
    history: [],
    currentIndex: 0,
    isEnded: false
  });
  const [isHistoryOpened, setIsHistoryOpened] = useState(false);
  const [playback, setPlayback] = useState(null);
  const playbackRef = useRef(null);
  const monitoringMountedRef = useRef(false);
  const trackRequestGenerationRef = useRef(0);
  const mapRef = useRef();
  const [mapInstance, setMapInstance] = useState(null);
  const wialonAccessToken = useSelector(
    (state: any) => state.wialonStore?.accessToken
  );
  const getWialonApi = useCallback(() => {
    if (!wialonAccessToken) return null;
    return wialonApi(wialonAccessToken);
  }, [wialonAccessToken]);

  /**
   * Функция для запроса виалоновского элемента по id
   */
  const fetchWialonItem = useCallback(async (vehicle) => {
    const wialon = getWialonApi();
    if (!wialon) return [];

    const { items } = await wialon.sections.Core.searchItems(
      vehicle.vehicle.wialonVehicleId
    );
    if (items) {
      const [item] = items;
      return item;
    } else {
      return [];
    }
  }, [getWialonApi]);

  useEffect(() => {}, [vehicles]);

  useEffect(() => {
    Object.keys(data).forEach((key) => {
      const itemId = parseInt(key);
      if (activeMonitoringVehicles.has(itemId)) {
        let vehicle = activeMonitoringVehicles.get(itemId);
        if (
        Array.isArray(data[key]) &&
        data[key].length &&
        data[key][0]?.trips)
        {
          const { y, x } = data[key][0]?.trips?.to;
          const { course } = data[key][0]?.trips;
          const direction = Number.isInteger(parseInt(course)) ?
          parseInt(course) :
          0;
          const speed = data[key][0]?.trips?.curr_speed ?? 0;
          if (y && x) {
            vehicle = {
              ...vehicle,
              direction,
              speed,
              geoPosition: {
                lat: y,
                lng: x
              },
              // $FlowFixMe
              polyline: [...vehicle.polyline, [y, x]]
            };
            if (parseInt(selectedMonitoringVehicle?.itemId) === itemId) {
              // $FlowFixMe
              setSelectedMonitoringVehicle(vehicle);
            }
            // $FlowFixMe
            activeMonitoringVehicles.set(itemId, vehicle);
          }
        }
      }
    });
  }, [activeMonitoringVehicles, data, selectedMonitoringVehicle]);

  useEffect(() => {
    const wialon = getWialonApi();
    if (!wialon) return undefined;

    let timerId = setInterval(() => {
      wialon.sections.Events.checkUpdates().
      then((data) => setData(data));
    }, 2000);
    return () => clearInterval(timerId);
  }, [getWialonApi]);

  useEffect(() => {
    const wialon = getWialonApi();
    if (!wialon) return;

    wialon.sections.Events.updateUnits(
      Array.from(activeMonitoringVehicles.keys())
    );
  }, [activeMonitoringVehicles, getWialonApi]);

  /**
   * Запрашивает последнее сообщение по ТС
   */
  const fetchVehicleLastMessage = useCallback(
    async (vehicle) => {
      const wialonItem = await fetchWialonItem(vehicle);
      const wialon = getWialonApi();
      if (!wialon) return undefined;

      const { messages } = await wialon.sections.Messages.loadLast({
        // $FlowFixMe
        itemId: wialonItem?.id,
        lastTime: parseInt(new Date().getTime() / 1000),
        lastCount: 1,
        loadCount: 1,
        flags: 0,
        flagsMask: 0
      });
      // $FlowFixMe
      return messages && { ...messages[0], itemId: wialonItem?.id };
    },
    [fetchWialonItem, getWialonApi]
  );

  const setPagination = useCallback((state) => {
    setPaginationObj((prev) => ({ ...prev, ...state }));
  }, []);

  /**
   * Подгружает список всех ТС
   */
  const fetchVehicles = useCallback(
    async (page = 1) => {
      try {
        const { pageSize } = pagination;
        const { data, totalCount } = await vehicleApi.fetchVehicles({
          receiveWialonData: true,
          page,
          pageSize
        });
        const vehicles = data.filter((v) => v.wialonVehicleId);

        const monitoringVehicles = await Promise.all(
          vehicles.map(async (vehicle, id) => {
            const baseVehicle = {
              id,
              vehicle,
              vehicleId: vehicle.id,
              sim: '+7 999 000 00 00',
              geoPosition: null,
              polyline: [],
              satellitesCount: 12,
              voltage: 11.5,
              signalLevel: 4,
              direction: 0,
              speed: 64,
              state: monitoringVehicleStatesEnum.stopped,
              status: monitoringVehicleStatusesEnum.nosignal,
              address: '',
              lastSynchronizedDate: moment().toISOString(),
              device: '',
              itemId: undefined
            };
            const message = await fetchVehicleLastMessage(baseVehicle);
            if (message?.pos?.y && message?.pos?.x) {
              // $FlowFixMe
              baseVehicle.geoPosition = {
                // $FlowFixMe
                lat: message?.pos?.y,
                // $FlowFixMe
                lng: message?.pos?.x
              };
            }
            baseVehicle.satellitesCount = message?.pos?.sc;
            baseVehicle.direction = message?.pos?.c;
            if (message?.itemId) {
              baseVehicle.itemId = message.itemId;
            }
            return baseVehicle;
          })
        );
        if (!monitoringMountedRef.current) return;
        setVehicles(monitoringVehicles);
        setOriginalVehicles(monitoringVehicles);
        setPagination({
          page,
          totalCount
        });
      } catch (err) {
        console.error(err);
      }
    },
    [fetchVehicleLastMessage, pagination, setPagination]
  );

  /**
   * Обработка нажатия на кнопку назад
   */
  const handleBackClick = useCallback(() => {
    goBack('/');
    showSidebarBurger();
    openSidebar();
  }, [showSidebarBurger, openSidebar]);

  /**
   * Функция изменения состояния истории
   * Принимает только callback в качестве аргумента
   * которого выступает предыдущее состояние,
   * а возвращаемым значением кусок данных стейта
   */
  const handleStateChange = useCallback(
    (
    fn) =>


    {
      setHistoryState((prevState) => ({ ...prevState, ...fn(prevState) }));
    },
    []
  );

  /**
   * Подгружает данные трека для истории
   */
  const fetchTrack = useCallback(
    async (vehicle) => {
      const { startDate, endDate } = historyState;
      if (!startDate || !endDate) return;

      const wialon = getWialonApi();
      if (!wialon) return;

      const generation = ++trackRequestGenerationRef.current;
      const isCurrent = () =>
        generation === trackRequestGenerationRef.current;

      setLoading(true);

      try {
        const { messages } =
          await wialon.sections.Messages.loadInterval({
            itemId: vehicle.itemId,
            // $FlowFixMe
            timeFrom: new Date(startDate).getTime() / 1000,
            // $FlowFixMe
            timeTo: new Date(endDate).getTime() / 1000,
            flags: 1,
            flagsMask: 65281,
            loadCount: 4294967295
          });

        if (!isCurrent()) return;

        setPlayback(null);
        handleStateChange(() => ({
          history: messages ?
          _orderBy(
            messages.map((message) => ({
              status: 'active',
              timestamp: new Date(message.t * 1000),
              geoPosition: {
                lat: message?.pos?.y,
                lng: message?.pos?.x
              },
              direction: message?.pos?.c,
              speed: message?.pos?.s,
              state: message?.pos?.s > 0 ? 'inmove' : 'stopped'
            })),
            'timestamp',
            'asc'
          ) :
          []
        }));
      } catch (e) {
        if (isCurrent()) {
          notification.error({ message: 'Ошибка', description: e.message });
        }
      } finally {
        if (isCurrent()) setLoading(false);
      }
    },
    [getWialonApi, handleStateChange, historyState.endDate, historyState.startDate]
  );

  /**
   * Обработка выбора ТС (в сайдбаре, на карте)
   */
  const handleVehicleSelect = useCallback(
    async (vehicle) => {
      try {
        if (!vehicle.itemId) throw new SyntaxError('ТС не привязано к виалону');
        const message = await fetchVehicleLastMessage(vehicle);
        setSelectedMonitoringVehicle({
          ...vehicle,
          address: await geocode(message?.pos?.y, message?.pos?.x),
          speed: message?.pos?.s,
          direction: message?.pos?.c,
          geoPosition: {
            lat: message?.pos?.y,
            lng: message?.pos?.x
          }
        });
        setVehicleInfoOpen(true);
      } catch (e) {
        notification.error({ message: 'Ошибка', description: e.message });
      }
    },
    [fetchVehicleLastMessage]
  );

  /**
   *
   * @param {*} wialonItemId
   * @param {*} vehicle
   * Обработка преключения выбора ТС для отображения или нет на карте
   */
  const handleActiveMonitoringVehicles = (
  wialonItemId,
  vehicle) =>
  {
    let activeVehicles = activeMonitoringVehicles;
    if (activeVehicles.has(wialonItemId)) {
      activeVehicles.delete(wialonItemId);
    } else {
      activeVehicles.set(wialonItemId, vehicle);
    }
    setActiveMonitoringVehicles(new Map(activeVehicles));
  };

  /**
   * Очищает фильтр по ТС
   */
  const cleanFilter = useCallback(() => setVehicles(originalVehicles), [
  originalVehicles]
  );

  /**
   * Применяет фильтр по ТС
   * Локальная фильтрация
   */
  const applyFilter = useCallback(
    (filters) => {
      const { stopped, disconnected, connected, moving } = filters;
      let filteredVehicles = originalVehicles;
      if (stopped) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) =>
          vehicle.state === monitoringVehicleStatesEnum.stopped
        );
      }
      if (disconnected) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) =>
          vehicle.status === monitoringVehicleStatusesEnum.nosignal
        );
      }
      if (connected) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) =>
          vehicle.status === monitoringVehicleStatusesEnum.active
        );
      }
      if (moving) {
        filteredVehicles = filteredVehicles.filter(
          (vehicle) =>
          vehicle.state === monitoringVehicleStatesEnum.inmove
        );
      }
      setVehicles(filteredVehicles);
    },
    [originalVehicles]
  );

  /**
   * Обработка закрытия информации по ТС
   */
  const closeVehicleInfo = useCallback(() => {
    setVehicleInfoOpen(false);
    // $FlowFixMe
    setSelectedMonitoringVehicle(undefined);
  }, []);

  /**
   * Обработка открытия истории
   */
  const handleHistoryOpen = useCallback(async (opened) => {
    setIsHistoryOpened(opened);
  }, []);

  useEffect(() => {
    if (selectedMonitoringVehicle) {
      fetchTrack(selectedMonitoringVehicle).then();
      return () => {
        trackRequestGenerationRef.current += 1;
      };
    }

    return undefined;
  }, [
  historyState.startDate,
  historyState.endDate,
  selectedMonitoringVehicle?.itemId,
  fetchTrack]
  );

  useEffect(() => {
    monitoringMountedRef.current = true;
    let active = true;
    const wialon = getWialonApi();
    async function mount() {
      if (!wialon) return;

      try {
        // Логинимся в виалоне
        await wialon.login();
        if (!active) return;
        closeSidebar();
        hideSidebarBurger();
        await fetchVehicles();
      } catch (error) {
        if (!active) return;
        notification.error({
          message: 'Ошибка',
          description: error.message
        });
      }
    }
    function unmount() {
      active = false;
      monitoringMountedRef.current = false;
      // Убиваем инстанс проигрывателя
      disposeTrackPlayback(playbackRef.current);
      playbackRef.current = null;
      // Подчищаемся в виалоне
      void wialon?.logout();
    }
    mount();
    return unmount;
    //eslint-disable-next-line
  }, [closeSidebar, getWialonApi, hideSidebarBurger]);

  /**
   * Подготовка данных и инициализация плагина для
   * поддержки воспроизведения у leaflet карт
   */
  useEffect(() => {
    if (
    mapInstance &&
    isHistoryOpened &&
    !playbackRef.current &&
    historyState.history.length)
    {
      const data = createPlaybackData(historyState.history);
      const instance = createTrackPlayback(data, mapInstance, {
        clockOptions: {
          speed: basePlaybackSpeed
        },
        targetOptions: {
          useImg: true,
          imgUrl: '/img/car.svg',
          height: 40,
          width: 28
        }
      });

      if (!instance) return undefined;

      playbackRef.current = instance;
      const unbind = bindPlaybackTicks(
        instance,
        historyState.history,
        handleStateChange
      );
      setPlayback(instance);

      return () => {
        unbind();
        disposeTrackPlayback(instance);
        if (playbackRef.current === instance) playbackRef.current = null;
        setPlayback((current) => current === instance ? null : current);
      };
    }

    return undefined;
  }, [
  historyState.history,
  isHistoryOpened,
  handleStateChange,
  mapInstance]
  );

  const { page, pageSize, totalCount } = pagination;

  return (
    <Wrapper>
      <Sidebar>
        <BackButton onClick={handleBackClick}>
          <Icon type="arrow-left" />
        </BackButton>
      </Sidebar>
      <Content>
        {loading && <Loading />}
        <VehiclesList
          handleActiveMonitoringVehicles={handleActiveMonitoringVehicles}
          activeMonitoringVehicles={activeMonitoringVehicles}
          onSelect={handleVehicleSelect}
          cleanFilter={cleanFilter}
          applyFilter={applyFilter}
          fetchVehicles={fetchVehicles}
          selectedMonitoringVehicle={selectedMonitoringVehicle}
          monitoringVehicles={vehicles}
          pagination={{
            location,
            page,
            pageSize,
            totalCount
          }} />


        <MapWrapper>
          <MonitoringMap
            ref={mapRef}
            onMapReady={setMapInstance}
            selectedMonitoringVehicle={selectedMonitoringVehicle}
            vehicles={Array.from(activeMonitoringVehicles.values())}
            history={historyState.history}
            currentHistoryItem={historyState.history[historyState.currentIndex]}
            isHistoryOpen={isHistoryOpened}
            onVehicleClick={handleVehicleSelect} />

          <VehicleInfo
            isHistoryOpened={isHistoryOpened}
            playback={playback}
            close={closeVehicleInfo}
            open={vehicleInfoOpen}
            monitoringVehicle={selectedMonitoringVehicle}
            historyState={historyState}
            onStateChange={handleStateChange}
            handleHistoryOpen={handleHistoryOpen} />

        </MapWrapper>
      </Content>
    </Wrapper>);

};

export default connect((state) => ({}), {
  hideSidebarBurger,
  closeSidebar,
  openSidebar,
  showSidebarBurger
})(MonitoringScreen);
